const LINK_MANAGEMENT_EXPERIENCE_TYPES = {
  CREATE: '[linkManagementExperience] createLink',
  EDIT: '[linkManagementExperience] editLink',
  DELETE: '[linkManagementExperience] deleteLink',
  FETCH_CLICKS: '[linkManagementExperience] fetchClicks'
}

export default LINK_MANAGEMENT_EXPERIENCE_TYPES
